import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio1To312(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMediaObjectRatio1To312"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2 2.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0m-2 0a1.5 1.5 0 1 1 3 0v7a1.5 1.5 0 0 1-3 0zm5.016 0a.5.5 0 0 1 .5-.5h5.953a.5.5 0 1 1 0 1H5.516a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h5.953a.5.5 0 1 1 0 1H5.516a.5.5 0 0 1-.5-.5m.5-2.5a.5.5 0 1 0 0 1h2.976a.5.5 0 0 0 0-1zm-.5 4.5a.5.5 0 0 1 .5-.5h2.976a.5.5 0 0 1 0 1H5.516a.5.5 0 0 1-.5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio1To312);
